import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const CustomerRestaurantDetailSlice = createSlice({
    name: "customerRestaurantDetail",
    initialState,
    reducers: {
        customerRestaurantDetailRequest(state) {
            state.loading = true;
        },
        customerRestaurantDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        customerRestaurantDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    customerRestaurantDetailRequest,
    customerRestaurantDetailRequestSuccess,
    customerRestaurantDetailRequestError,
} = CustomerRestaurantDetailSlice.actions;

export default CustomerRestaurantDetailSlice.reducer;
